import { Box, IconButton, Menu, MenuItem, Typography } from "@mui/material";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { selectServiceProviders } from "../../stateManagement/serviceProviderSlice";
import { removeSelectedServiceProvider, selectSelectedServiceProvider, setSelectedServiceProvider } from "../../stateManagement/selectedServiceProviderSlice";
import { AppDispatch } from "../../stateManagement/store";
import { useDispatch } from "react-redux";
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import InfoComponent from "../../customComponents/InfoComponent";
import ListIcon from '@mui/icons-material/List';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import AddIcon from '@mui/icons-material/Add';

const ServiceProviderMenu: React.FC<{
    top: number;
    setListType: (input: 'timeSheet' | 'gridTable') => void;
    listType: 'timeSheet' | 'gridTable';
    openNewAppointment: () => void;
}> = ({ top, setListType, listType, openNewAppointment }) => {

    const dispatch = useDispatch<AppDispatch>();

    const serviceProviders = useSelector(selectServiceProviders);

    const selectedServiceProvider = useSelector(selectSelectedServiceProvider);

    const [anchorElSP, setAnchorElSP] = useState<null | HTMLElement>(null);
    const openSPMenu = Boolean(anchorElSP);

    const handleSPMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElSP(event.currentTarget);
    };

    const handleSelectServiceProvider = (input: { serviceProviderId: string; fullName?: string; }) => {
        if (input.serviceProviderId !== selectedServiceProvider.serviceProviderId) {
            dispatch(setSelectedServiceProvider(input));
        }
        setAnchorElSP(null);
    };

    const otherServiceProviders = () => {
        return serviceProviders.filter((user) => user.serviceProviderId !== selectedServiceProvider.serviceProviderId);
    };

    const handleBack = () => {
        dispatch(removeSelectedServiceProvider());
    };

    return (
        selectedServiceProvider.serviceProviderId ?
            <React.Fragment >
                <Box sx={{
                    position: 'fixed',
                    zIndex: 11,
                    top: { top },
                    left: 0,
                    right: 0,
                    height: 45,
                    backgroundColor: 'background.paper',
                    color: 'text.primary',
                    borderBottom: '1px solid #ddd',
                    padding: '8px 16px',
                    display: 'flex',
                    justifyContent: 'flex-start',
                    alignItems: 'center',
                }}
                >
                    <InfoComponent infoContent='Return to the list of service providers'>
                        <IconButton size="small" onClick={handleBack} sx={{ marginRight: '7px' }} >
                            <KeyboardArrowLeftIcon />
                        </IconButton>
                    </InfoComponent>
                    <InfoComponent infoContent={`Use this section to manage appointments with ${selectedServiceProvider.name}. You can:
- View and manage appointments via timesheet or grid.
- Add or edit bookings.
- View availability through highlighted by color-coded rows.
Click the name to select a different service provider. `}>
                        <Typography onClick={handleSPMenuOpen} variant="h6" style={{ cursor: (otherServiceProviders().length > 0) ? 'pointer' : 'auto', display: 'inline' }} >
                            {`${selectedServiceProvider.name}`}
                        </Typography>
                    </InfoComponent>
                    {otherServiceProviders().length > 0 &&
                        <Menu className="root-menu" anchorEl={anchorElSP} open={openSPMenu} onClose={() => setAnchorElSP(null)}>
                            {otherServiceProviders().map((sp) => (
                                <MenuItem key={sp.serviceProviderId} onClick={() => handleSelectServiceProvider(sp)}>
                                    {sp.name}
                                </MenuItem>
                            ))}
                        </Menu>
                    }
                    <InfoComponent infoContent={`Switch to ${listType === 'gridTable' ? 'Timesheet View' : 'Grid View'} for managing appointments`} >
                        <IconButton size="small" onClick={() => listType === 'gridTable' ? setListType('timeSheet') : setListType('gridTable')} sx={{ marginLeft: '7px' }} >
                            {listType === 'gridTable' ? <AccessTimeIcon /> : <ListIcon />}
                        </IconButton>
                    </InfoComponent>
                    {listType === 'gridTable' &&
                        <InfoComponent infoContent='Add new appointment by client or guest'>
                            <IconButton size='small' onClick={() => openNewAppointment()} sx={{ marginLeft: '7px' }}>
                                <AddIcon />
                            </IconButton>
                        </InfoComponent>
                    }
                </Box>
            </React.Fragment>
            : null);
};

export default ServiceProviderMenu;